// extracted by mini-css-extract-plugin
export default {"container":"Card_container__K7EcC","reset-scale":"Card_reset-scale__GVP3P","grow-shrink-grow":"Card_grow-shrink-grow__+CCR7","cover":"Card_cover__Ss36Q"};